declare const jQuery: any;
const $ = jQuery;

let scrolling: boolean = false;

const config = Object.freeze({
	duration: 400
});

const $mainHeader = $(".main-header").first();

export function init()
{
	$(".scroll-button-container, [data-scroll-button-container]").each(initContainer);
}

function getOffset($button): number
{
	if ($button.is('[data-no-offset]'))
	{
		return 0;
	}
	if ($mainHeader.css("position") === "fixed")
	{
		return -$mainHeader.outerHeight();
	}
	return 0;
}

function initContainer(): void
{
	const $container = $(this);
	const $button = $container.find(".scroll-down-button, [data-scroll-down-button]");
	initScrollDownButton($button, $container);
}

function getNextContainer($container: any): any
{
	while (true)
	{
		const $next: any = $container.next(`:not([data-scroll-down-ignore])`);

		if ($next.length > 0)
		{
			return $next;
		}
	
		$container = $container.parent();
		if ($container.length === 0)
		{
			return undefined;
		}
	}
}

function initScrollDownButton($button, $container?): void
{
	$button = $($button);

	if (!$container)
	{
		$container = $button.closest(".scroll-button-container, [data-scroll-button-container]");
	}
	else
	{
		$container = $($container);
	}
	
	if ($container.length === 0)
	{
		console.error("Failed to find container for scroll down button");
		return;
	}
	
	$button.on("click", event => {
		if (scrolling)
		{
			return;
		}
		scrolling = true;
		let offset: number = getOffset($button);
		const $next = getNextContainer($container);
		if ($next)
		{
			const addOffset: number = parseInt($next.attr("data-scroll-down-offset"), 10);
			if (addOffset)
			{
				offset += addOffset;
			}
			$.scrollTo($next, config.duration, {
				offset: { top: offset },
				axis: "y",
				onAfter: function onAfter() {
					scrolling = false;
				}
			});
		}
		
	});
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].initScrollDownButton = initScrollDownButton;
